module.exports = __webpack_public_path__ + "img/4.45383216.png";